import {
  Component
} from '@angular/core';

import { FocusDirective } from './focus.directive';

/**
 * Focuses empty anchor element when rendered. Could be used to scroll to the top of long modals or scrollable divs
 * and setting initial focus when state navigation does not happen but components on the screen are replaced
 * (e.g. as part of multiple step process such as transfers or order entry)
 */
@Component({
  imports: [
    FocusDirective
  ],
  selector: 'td-wb-focus-anchor',
  templateUrl: 'focus-anchor.component.html',
  styleUrls: ['focus-anchor.component.scss']
})
export class FocusAnchorComponent {
}
